export async function logout(navigate) {
  const role = getRoleFromStorage();
  let navTo = role === "AGENT" ? "/authentication/agent-sign-in" : "/authentication/sign-in";
  localStorage.removeItem("auth");
  window.dispatchEvent(new Event("authChanged"));
  navigate(navTo, { replace: true });
}

export async function clearTokenAndRedirectToLogin(navigate) {
  const role = getRoleFromStorage();
  let navTo = role === "AGENT" ? "/authentication/agent-sign-in" : "/authentication/sign-in";
  localStorage.removeItem("auth");
  window.dispatchEvent(new Event("authChanged"));
  navigate(navTo, { replace: true });
}

export function getRoleFromStorage() {
  try {
    const auth = JSON.parse(localStorage.getItem("auth") || "null");
    return auth?.role || null; // "ADMIN" | "AGENT"
  } catch (e) {
    return null;
  }
}

export const getAuth = () => {
  try {
    return JSON.parse(localStorage.getItem("auth") || "{}");
  } catch (e) {
    return {};
  }
};

export const getAgentIdFromAuth = () => {
  const a = getAuth();
  return a?.role === "AGENT" ? a?.user?.id : null;
};
